// Action Types
import { RESET_ROLE, RoleActionTypes, SET_ROLE } from '../../role/redux/actionTypes';
import { RESET_USER, SET_USER, UserActionTypes } from '../../user/redux/actionTypes';
import { PermissionsActionTypes, TOGGLE_ALL_PERMISSIONS, UPDATE_PERMISSIONS } from './actionTypes';
// Types
import { Permission } from '../objects/permission';
import { PermissionsState } from '../objects/permissionsState';

const initialState: PermissionsState = {
    view_client: false,
    add_client: false,
    change_client: false,
    delete_client: false,
    view_clientnetwork: false,
    add_clientnetwork: false,
    change_clientnetwork: false,
    delete_clientnetwork: false,
    view_user: false,
    add_user: false,
    change_user: false,
    delete_user: false,
    multi_deactivation: false,
    multi_deletion: false,
    view_authgroup: false,
    add_authgroup: false,
    change_authgroup: false,
    delete_authgroup: false,
    view_private_destinations: false,
    add_destination: false,
    change_destinationversion: false,
    delete_destination: false,
    change_destination: false,
    view_category: false,
    add_category: false,
    change_category: false,
    delete_category: false,
    view_private_guides: false,
    add_guide: false,
    change_guideversion: false,
    delete_guide: false,
    change_guide: false,
    view_rubric: false,
    add_rubric: false,
    change_rubric: false,
    delete_rubric: false,
    view_picture: false,
    add_picture: false,
    change_picture: false,
    delete_picture: false,
    view_filecategory: false,
    add_filecategory: false,
    change_filecategory: false,
    delete_filecategory: false,
    view_activityproduct: false,
    change_activityproduct: false,
    view_favoritehotel: false,
    view_trip: false,
    add_trip: false,
    change_trip: false,
    delete_trip: false,
    view_typical_itinerary: false,
    create_typical_itinerary: false,
    update_typical_itinerary: false,
    delete_typical_itinerary: false,
    view_currencyclient: false,
    add_currencyclient: false,
    change_currencyclient: false,
    delete_currencyclient: false,
    view_marginprice: false,
    add_marginprice: false,
    change_marginprice: false,
    delete_marginprice: false,
    view_customproduct: false,
    add_customproduct: false,
    change_customproduct: false,
    delete_customproduct: false,
    view_corporatecodeclient: false,
    add_corporatecodeclient: false,
    change_corporatecodeclient: false,
    delete_corporatecodeclient: false,
    view_airlineclientcode: false,
    add_airlineclientcode: false,
    change_airlineclientcode: false,
    delete_airlineclientcode: false,
    view_flightboparameter: false,
    add_flightboparameter: false,
    change_flightboparameter: false,
    delete_flightboparameter: false,
    view_customaccommodation: false,
    add_customaccommodation: false,
    change_customaccommodation: false,
    delete_customaccommodation: false,
    view_customflight: false,
    delete_customflight: false,
    change_customflight: false,
    add_customflight: false,
    view_mapcustomprovider: false,
    add_mapcustomprovider: false,
    change_mapcustomprovider: false,
    delete_mapcustomprovider: false,
    add_roominglist: false,
    change_roominglist: false,
    delete_roominglist: false,
    view_roominglist: false,
    view_quotationtemplate: false,
    add_quotationtemplate: false,
    change_quotationtemplate: false,
    delete_quotationtemplate: false,
    view_quotationrubrics: false,
    add_quotationrubrics: false,
    change_quotationrubrics: false,
    delete_quotationrubrics: false,
    view_quotationcategories: false,
    add_quotationcategories: false,
    change_quotationcategories: false,
    delete_quotationcategories: false,
    view_circuits: false,
    add_circuits: false,
    change_circuits: false,
    delete_circuits: false,
    view_packages: false,
    add_packages: false,
    change_packages: false,
    delete_packages: false,
    view_eventsite: false,
    add_eventsite: false,
    change_eventsite: false,
    delete_eventsite: false,
    view_automaticproduct: false,
    delete_automaticproduct: false,
    change_automaticproduct: false,
    add_automaticproduct: false,
    view_customproductpricemodel: false,
    delete_customproductpricemodel: false,
    change_customproductpricemodel: false,
    add_customproductpricemodel: false,
    delete_restricted: false,
    view_modelmail: false,
    add_modelmail: false,
    change_modelmail: false,
    delete_modelmail: false,
    view_emailcontact: false,
    add_emailcontact: false,
    change_emailcontact: false,
    delete_emailcontact: false,
    view_roadbook: false,
    add_roadbook: false,
    change_roadbook: false,
    delete_roadbook: false,
    view_roadbookcategory: false,
    add_roadbookcategory: false,
    change_roadbookcategory: false,
    delete_roadbookcategory: false,
    view_roadbookrubric: false,
    add_roadbookrubric: false,
    change_roadbookrubric: false,
    delete_roadbookrubric: false,
    view_roadbookpicturetype: false,
    add_roadbookpicturetype: false,
    change_roadbookpicturetype: false,
    delete_roadbookpicturetype: false,
    view_roadbookconfiguration: false,
    add_roadbookconfiguration: false,
    change_roadbookconfiguration: false,
    delete_roadbookconfiguration: false,
    export_trip: false,
    view_packagecategory: false,
    add_packagecategory: false,
    change_packagecategory: false,
    delete_packagecategory: false,
    view_circuitcancellationrule: false,
    add_circuitcancellationrule: false,
    change_circuitcancellationrule: false,
    delete_circuitcancellationrule: false,
    add_translation: false,
    change_translation: false,
    delete_translation: false,
    view_translation: false,
    view_insurance: false,
    add_insurance: false,
    change_insurance: false,
    delete_insurance: false,
    view_insuranceproductfamily: false,
    add_insuranceproductfamily: false,
    change_insuranceproductfamily: false,
    delete_insuranceproductfamily: false,
    view_insurancedocument: false,
    add_insurancedocument: false,
    change_insurancedocument: false,
    delete_insurancedocument: false,
    view_insuranceminisitegeneration: false,
    add_insuranceminisitegeneration: false,
    change_insuranceminisitegeneration: false,
    delete_insuranceminisitegeneration: false,
    view_insurancescontract: false,
    add_insurancescontract: false,
    change_insurancescontract: false,
    delete_insurancescontract: false,
    view_insuranceproductdiscount: false,
    add_insuranceproductdiscount: false,
    change_insuranceproductdiscount: false,
    delete_insuranceproductdiscount: false,
    view_insuranceincentive: false,
    add_insuranceincentive: false,
    change_insuranceincentive: false,
    delete_insuranceincentive: false,
    view_warranty: false,
    add_warranty: false,
    change_warranty: false,
    delete_warranty: false,
    view_claimsmotif: false,
    add_claimsmotif: false,
    change_claimsmotif: false,
    delete_claimsmotif: false,
    view_network_director: false,
    add_network_director: false,
    change_network_director: false,
    delete_network_director: false,
    view_commercial: false,
    add_commercial: false,
    change_commercial: false,
    delete_commercial: false,
    view_commercialinformation: false,
    add_commercialinformation: false,
    change_commercialinformation: false,
    delete_commercialinformation: false,
    view_paymentcenter: false,
    add_paymentcenter: false,
    change_paymentcenter: false,
    delete_paymentcenter: false,
    view_purchases: false,
    add_purchases: false,
    change_purchases: false,
    delete_purchases: false,
    view_sales: false,
    add_sales: false,
    change_sales: false,
    delete_sales: false,
    view_accountsettings: false,
    add_accountsettings: false,
    change_accountsettings: false,
    delete_accountsettings: false,
    view_exportsettings: false,
    add_exportsettings: false,
    change_exportsettings: false,
    delete_exportsettings: false,
    view_settlement: false,
    add_settlement: false,
    change_settlement: false,
    delete_settlement: false,
    view_invoicehistory: false,
    add_invoicehistory: false,
    change_invoicehistory: false,
    delete_invoicehistory: false,
    update_lock_object: false,
};

export default (state: PermissionsState = initialState, action: PermissionsActionTypes | UserActionTypes | RoleActionTypes): PermissionsState => {
    switch (action.type) {
        case RESET_ROLE: {
            return { ...initialState };
        }
        case RESET_USER: {
            return { ...initialState };
        }
        case SET_USER: {
            let new_state: PermissionsState = { ...state };
            if (action.payload.perms) {
                action.payload.perms.map((perm: Permission) => {
                    if (new_state[perm.codename] !== undefined) {
                        new_state[perm.codename] = true;
                    }
                });
            }
            return { ...new_state };
        }
        case SET_ROLE: {
            let new_state: PermissionsState = { ...state };
            if (action.payload.permissions !== null) {
                action.payload.permissions.map((perm: Permission) => {
                    if (new_state[perm.codename] !== undefined) {
                        new_state[perm.codename] = true;
                    }
                });
            }
            return { ...new_state };
        }
        case TOGGLE_ALL_PERMISSIONS: {
            let new_state = { ...state };
            const checkPermissions = (permission: string) => {
                if (action.payload.profile?.is_superuser) {
                    return true;
                }
                const permissions = action.payload.permissions;
                if (permissions === null) {
                    return false;
                }
                for (let i = 0; i < permissions.length; i++) {
                    if (permissions[i].codename === permission) {
                        return true;
                    }
                }
                return false;
            };
            for (const [key] of Object.entries(new_state)) {
                new_state[key] = action.payload.value ? checkPermissions(key) : false;
            }
            return { ...new_state };
        }
        case UPDATE_PERMISSIONS: {
            let new_state = { ...state };
            if (action.payload.codename.includes('all_')) {
                switch (action.payload.codename) {
                    case 'all_client':
                        new_state.view_client = action.payload.value;
                        new_state.add_client = action.payload.value;
                        new_state.change_client = action.payload.value;
                        new_state.delete_client = action.payload.value;
                        if (!action.payload.value) {
                            new_state.add_user = false;
                            new_state.change_user = false;
                            new_state.delete_user = false;
                        }
                        break;
                    case 'all_clientnetwork':
                        new_state.view_clientnetwork = action.payload.value;
                        new_state.add_clientnetwork = action.payload.value;
                        new_state.change_clientnetwork = action.payload.value;
                        new_state.delete_clientnetwork = action.payload.value;
                        break;
                    case 'all_user':
                        new_state.view_user = action.payload.value;
                        new_state.add_user = action.payload.value;
                        new_state.change_user = action.payload.value;
                        new_state.delete_user = action.payload.value;
                        break;
                    case 'all_authgroup':
                        new_state.view_authgroup = action.payload.value;
                        new_state.add_authgroup = action.payload.value;
                        new_state.change_authgroup = action.payload.value;
                        new_state.delete_authgroup = action.payload.value;
                        break;
                    case 'all_private_destinations':
                        new_state.view_private_destinations = action.payload.value;
                        new_state.add_destination = action.payload.value;
                        new_state.change_destination = action.payload.value;
                        new_state.delete_destination = action.payload.value;
                        break;
                    case 'all_category':
                        new_state.view_category = action.payload.value;
                        new_state.add_category = action.payload.value;
                        new_state.change_category = action.payload.value;
                        new_state.delete_category = action.payload.value;
                        break;
                    case 'all_private_guides':
                        new_state.view_private_guides = action.payload.value;
                        new_state.add_guide = action.payload.value;
                        new_state.change_guide = action.payload.value;
                        new_state.delete_guide = action.payload.value;
                        break;
                    case 'all_rubric':
                        new_state.view_rubric = action.payload.value;
                        new_state.add_rubric = action.payload.value;
                        new_state.change_rubric = action.payload.value;
                        new_state.delete_rubric = action.payload.value;
                        break;
                    case 'all_private_picture':
                        new_state.view_picture = action.payload.value;
                        new_state.add_picture = action.payload.value;
                        new_state.change_picture = action.payload.value;
                        new_state.delete_picture = action.payload.value;
                        break;
                    case 'all_filecategory':
                        new_state.view_filecategory = action.payload.value;
                        new_state.add_filecategory = action.payload.value;
                        new_state.change_filecategory = action.payload.value;
                        new_state.delete_filecategory = action.payload.value;
                        break;
                    case 'all_trip':
                        new_state.view_trip = action.payload.value;
                        new_state.add_trip = action.payload.value;
                        new_state.change_trip = action.payload.value;
                        new_state.delete_trip = action.payload.value;
                        break;
                    case 'all_itinerary_type':
                        new_state.view_typical_itinerary = action.payload.value;
                        new_state.create_typical_itinerary = action.payload.value;
                        new_state.update_typical_itinerary = action.payload.value;
                        new_state.delete_typical_itinerary = action.payload.value;
                        break;
                    case 'all_currencyclient':
                        new_state.view_currencyclient = action.payload.value;
                        new_state.add_currencyclient = action.payload.value;
                        new_state.change_currencyclient = action.payload.value;
                        new_state.delete_currencyclient = action.payload.value;
                        break;
                    case 'all_marginprice':
                        new_state.view_marginprice = action.payload.value;
                        new_state.add_marginprice = action.payload.value;
                        new_state.change_marginprice = action.payload.value;
                        new_state.delete_marginprice = action.payload.value;
                        break;
                    case 'all_excursion':
                        new_state.view_customproduct = action.payload.value;
                        new_state.add_customproduct = action.payload.value;
                        new_state.change_customproduct = action.payload.value;
                        new_state.delete_customproduct = action.payload.value;
                        break;
                    case 'all_airlineclientcode':
                        new_state.view_airlineclientcode = action.payload.value;
                        new_state.add_airlineclientcode = action.payload.value;
                        new_state.change_airlineclientcode = action.payload.value;
                        new_state.delete_airlineclientcode = action.payload.value;
                        break;
                    case 'all_flightboparameter':
                        new_state.view_flightboparameter = action.payload.value;
                        new_state.add_flightboparameter = action.payload.value;
                        new_state.change_flightboparameter = action.payload.value;
                        new_state.delete_flightboparameter = action.payload.value;
                        break;
                    case 'all_corporatecodeclient':
                        new_state.view_corporatecodeclient = action.payload.value;
                        new_state.add_corporatecodeclient = action.payload.value;
                        new_state.change_corporatecodeclient = action.payload.value;
                        new_state.delete_corporatecodeclient = action.payload.value;
                        break;
                    case 'all_customaccommodation':
                        new_state.view_customaccommodation = action.payload.value;
                        new_state.add_customaccommodation = action.payload.value;
                        new_state.change_customaccommodation = action.payload.value;
                        new_state.delete_customaccommodation = action.payload.value;
                        break;
                    case 'all_customflight':
                        new_state.view_customflight = action.payload.value;
                        new_state.add_customflight = action.payload.value;
                        new_state.change_customflight = action.payload.value;
                        new_state.delete_customflight = action.payload.value;
                        break;
                    case 'all_circuits':
                        new_state.view_circuits = action.payload.value;
                        new_state.add_circuits = action.payload.value;
                        new_state.change_circuits = action.payload.value;
                        new_state.delete_circuits = action.payload.value;
                        break;
                    case 'all_packages':
                        new_state.view_packages = action.payload.value;
                        new_state.add_packages = action.payload.value;
                        new_state.change_packages = action.payload.value;
                        new_state.delete_packages = action.payload.value;
                        break;
                    case 'all_packagecategory':
                        new_state.view_packagecategory = action.payload.value;
                        new_state.add_packagecategory = action.payload.value;
                        new_state.change_packagecategory = action.payload.value;
                        new_state.delete_packagecategory = action.payload.value;
                        break;
                    case 'all_circuitcancellationrule':
                        new_state.view_circuitcancellationrule = action.payload.value;
                        new_state.add_circuitcancellationrule = action.payload.value;
                        new_state.change_circuitcancellationrule = action.payload.value;
                        new_state.delete_circuitcancellationrule = action.payload.value;
                        break;
                    case 'all_mapcustomprovider':
                        new_state.view_mapcustomprovider = action.payload.value;
                        new_state.add_mapcustomprovider = action.payload.value;
                        new_state.change_mapcustomprovider = action.payload.value;
                        new_state.delete_mapcustomprovider = action.payload.value;
                        break;
                    case 'all_roominglist':
                        new_state.view_roominglist = action.payload.value;
                        new_state.add_roominglist = action.payload.value;
                        new_state.change_roominglist = action.payload.value;
                        new_state.delete_roominglist = action.payload.value;
                        break;
                    case 'all_quotationtemplate':
                        new_state.view_quotationtemplate = action.payload.value;
                        new_state.add_quotationtemplate = action.payload.value;
                        new_state.change_quotationtemplate = action.payload.value;
                        new_state.delete_quotationtemplate = action.payload.value;
                        break;
                    case 'all_quotationcategories':
                        new_state.view_quotationcategories = action.payload.value;
                        new_state.add_quotationcategories = action.payload.value;
                        new_state.change_quotationcategories = action.payload.value;
                        new_state.delete_quotationcategories = action.payload.value;
                        break;
                    case 'all_quotationrubrics':
                        new_state.view_quotationrubrics = action.payload.value;
                        new_state.add_quotationrubrics = action.payload.value;
                        new_state.change_quotationrubrics = action.payload.value;
                        new_state.delete_quotationrubrics = action.payload.value;
                        break;
                    case 'all_eventsite':
                        new_state.view_eventsite = action.payload.value;
                        new_state.add_eventsite = action.payload.value;
                        new_state.change_eventsite = action.payload.value;
                        new_state.delete_eventsite = action.payload.value;
                        break;
                    case 'all_automaticproduct':
                        new_state.view_automaticproduct = action.payload.value;
                        new_state.delete_automaticproduct = action.payload.value;
                        new_state.change_automaticproduct = action.payload.value;
                        new_state.add_automaticproduct = action.payload.value;
                        break;
                    case 'all_customproductpricemodel':
                        new_state.view_customproductpricemodel = action.payload.value;
                        new_state.delete_customproductpricemodel = action.payload.value;
                        new_state.change_customproductpricemodel = action.payload.value;
                        new_state.add_customproductpricemodel = action.payload.value;
                        break;
                    case 'all_modelmail':
                        new_state.view_modelmail = action.payload.value;
                        new_state.delete_modelmail = action.payload.value;
                        new_state.change_modelmail = action.payload.value;
                        new_state.add_modelmail = action.payload.value;
                        break;
                    case 'all_translation':
                        new_state.view_translation = action.payload.value;
                        new_state.delete_translation = action.payload.value;
                        new_state.change_translation = action.payload.value;
                        new_state.add_translation = action.payload.value;
                        break;
                    case 'all_emailcontact':
                        new_state.view_emailcontact = action.payload.value;
                        new_state.delete_emailcontact = action.payload.value;
                        new_state.change_emailcontact = action.payload.value;
                        new_state.add_emailcontact = action.payload.value;
                        break;
                    case 'all_roadbook':
                        new_state.view_roadbook = action.payload.value;
                        new_state.add_roadbook = action.payload.value;
                        new_state.change_roadbook = action.payload.value;
                        new_state.delete_roadbook = action.payload.value;
                        break;
                    case 'all_roadbookcategory':
                        new_state.view_roadbookcategory = action.payload.value;
                        new_state.add_roadbookcategory = action.payload.value;
                        new_state.change_roadbookcategory = action.payload.value;
                        new_state.delete_roadbookcategory = action.payload.value;
                        break;
                    case 'all_roadbookrubric':
                        new_state.view_roadbookrubric = action.payload.value;
                        new_state.add_roadbookrubric = action.payload.value;
                        new_state.change_roadbookrubric = action.payload.value;
                        new_state.delete_roadbookrubric = action.payload.value;
                        break;
                    case 'all_roadbookpicturetype':
                        new_state.view_roadbookpicturetype = action.payload.value;
                        new_state.add_roadbookpicturetype = action.payload.value;
                        new_state.change_roadbookpicturetype = action.payload.value;
                        new_state.delete_roadbookpicturetype = action.payload.value;
                        break;
                    case 'all_roadbookconfiguration':
                        new_state.view_roadbookconfiguration = action.payload.value;
                        new_state.add_roadbookconfiguration = action.payload.value;
                        new_state.change_roadbookconfiguration = action.payload.value;
                        new_state.delete_roadbookconfiguration = action.payload.value;
                        break;
                    case 'all_insurance':
                        new_state.view_insurance = action.payload.value;
                        new_state.add_insurance = action.payload.value;
                        new_state.change_insurance = action.payload.value;
                        new_state.delete_insurance = action.payload.value;
                        break;
                    case 'all_insuranceproductfamily':
                        new_state.view_insuranceproductfamily = action.payload.value;
                        new_state.add_insuranceproductfamily = action.payload.value;
                        new_state.change_insuranceproductfamily = action.payload.value;
                        new_state.delete_insuranceproductfamily = action.payload.value;
                        break;
                    case 'all_insurancedocument':
                        new_state.view_insurancedocument = action.payload.value;
                        new_state.add_insurancedocument = action.payload.value;
                        new_state.change_insurancedocument = action.payload.value;
                        new_state.delete_insurancedocument = action.payload.value;
                        break;
                    case 'all_insuranceminisitegeneration':
                        new_state.view_insuranceminisitegeneration = action.payload.value;
                        new_state.add_insuranceminisitegeneration = action.payload.value;
                        new_state.change_insuranceminisitegeneration = action.payload.value;
                        new_state.delete_insuranceminisitegeneration = action.payload.value;
                        break;
                    case 'all_insurancescontract':
                        new_state.view_insurancescontract = action.payload.value;
                        new_state.add_insurancescontract = action.payload.value;
                        new_state.change_insurancescontract = action.payload.value;
                        new_state.delete_insurancescontract = action.payload.value;
                        break;
                    case 'all_insuranceproductdiscount':
                        new_state.view_insuranceproductdiscount = action.payload.value;
                        new_state.add_insuranceproductdiscount = action.payload.value;
                        new_state.change_insuranceproductdiscount = action.payload.value;
                        new_state.delete_insuranceproductdiscount = action.payload.value;
                        break;
                    case 'all_insuranceincentive':
                        new_state.view_insuranceincentive = action.payload.value;
                        new_state.add_insuranceincentive = action.payload.value;
                        new_state.change_insuranceincentive = action.payload.value;
                        new_state.delete_insuranceincentive = action.payload.value;
                        break;
                    case 'all_warranty':
                        new_state.view_warranty = action.payload.value;
                        new_state.add_warranty = action.payload.value;
                        new_state.change_warranty = action.payload.value;
                        new_state.delete_warranty = action.payload.value;
                        break;
                    case 'all_claimsmotif':
                        new_state.view_claimsmotif = action.payload.value;
                        new_state.add_claimsmotif = action.payload.value;
                        new_state.change_claimsmotif = action.payload.value;
                        new_state.delete_claimsmotif = action.payload.value;
                        break;
                    case 'all_network_director':
                        new_state.view_network_director = action.payload.value;
                        new_state.add_network_director = action.payload.value;
                        new_state.change_network_director = action.payload.value;
                        new_state.delete_network_director = action.payload.value;
                        break;
                    case 'all_commercial':
                        new_state.view_commercial = action.payload.value;
                        new_state.add_commercial = action.payload.value;
                        new_state.change_commercial = action.payload.value;
                        new_state.delete_commercial = action.payload.value;
                        break;
                    case 'all_commercialinformation':
                        new_state.view_commercialinformation = action.payload.value;
                        new_state.add_commercialinformation = action.payload.value;
                        new_state.change_commercialinformation = action.payload.value;
                        new_state.delete_commercialinformation = action.payload.value;
                        break;
                    case 'all_paymentcenter':
                        new_state.view_paymentcenter = action.payload.value;
                        new_state.add_paymentcenter = action.payload.value;
                        new_state.change_paymentcenter = action.payload.value;
                        new_state.delete_paymentcenter = action.payload.value;
                        break;
                    case 'all_purchases':
                        new_state.view_purchases = action.payload.value;
                        new_state.add_purchases = action.payload.value;
                        new_state.change_purchases = action.payload.value;
                        new_state.delete_purchases = action.payload.value;
                        break;
                    case 'all_accountingbook':
                        new_state.view_accountingbook = action.payload.value;
                        new_state.add_accountingbook = action.payload.value;
                        new_state.change_accountingbook = action.payload.value;
                        new_state.delete_accountingbook = action.payload.value;
                        break;
                    case 'all_invoicehistory':
                        new_state.view_invoicehistory = action.payload.value;
                        new_state.add_invoicehistory = action.payload.value;
                        new_state.change_invoicehistory = action.payload.value;
                        new_state.delete_invoicehistory = action.payload.value;
                        break;
                    case 'all_settlement':
                        new_state.view_settlement = action.payload.value;
                        new_state.add_settlement = action.payload.value;
                        new_state.change_settlement = action.payload.value;
                        new_state.delete_settlement = action.payload.value;
                        break;
                }
            } else {
                new_state[action.payload.codename] = action.payload.value;
            }
            if (!action.payload.value) {
                switch (action.payload.codename) {
                    case 'view_client':
                        new_state.add_client = false;
                        new_state.change_client = false;
                        new_state.delete_client = false;
                        new_state.add_user = false;
                        new_state.change_user = false;
                        new_state.delete_user = false;
                        break;
                    case 'view_clientnetwork':
                        new_state.add_clientnetwork = false;
                        new_state.change_clientnetwork = false;
                        new_state.delete_clientnetwork = false;
                        break;
                    case 'view_user':
                        new_state.add_user = false;
                        new_state.change_user = false;
                        new_state.delete_user = false;
                        new_state.multi_deactivation = false;
                        new_state.multi_deletion = false;
                        break;
                    case 'view_authgroup':
                        new_state.add_authgroup = false;
                        new_state.change_authgroup = false;
                        new_state.delete_authgroup = false;
                        break;
                    case 'view_private_destinations':
                        new_state.add_destination = false;
                        new_state.change_destination = false;
                        new_state.delete_destination = false;
                        break;
                    case 'view_category':
                        new_state.add_category = false;
                        new_state.change_category = false;
                        new_state.delete_category = false;
                        break;
                    case 'view_private_guides':
                        new_state.add_guide = false;
                        new_state.change_guide = false;
                        new_state.delete_guide = false;
                        break;
                    case 'view_rubric':
                        new_state.add_rubric = false;
                        new_state.change_rubric = false;
                        new_state.delete_rubric = false;
                        break;
                    case 'view_picture':
                        new_state.add_picture = false;
                        new_state.change_picture = false;
                        new_state.delete_picture = false;
                        break;
                    case 'view_filecategory':
                        new_state.add_filecategory = false;
                        new_state.change_filecategory = false;
                        new_state.delete_filecategory = false;
                        break;
                    case 'view_currencyclient':
                        new_state.add_currencyclient = false;
                        new_state.change_currencyclient = false;
                        new_state.delete_currencyclient = false;
                        break;
                    case 'view_marginprice':
                        new_state.add_marginprice = false;
                        new_state.change_marginprice = false;
                        new_state.delete_marginprice = false;
                        break;
                    case 'view_customproduct':
                        new_state.add_customproduct = false;
                        new_state.change_customproduct = false;
                        new_state.delete_customproduct = false;
                        break;
                    case 'view_corporatecodeclient':
                        new_state.add_corporatecodeclient = false;
                        new_state.change_corporatecodeclient = false;
                        new_state.delete_corporatecodeclient = false;
                        break;
                    case 'view_airlineclientcode':
                        new_state.add_airlineclientcode = false;
                        new_state.change_airlineclientcode = false;
                        new_state.delete_airlineclientcode = false;
                        break;
                    case 'view_flightboparameter':
                        new_state.add_flightboparameter = false;
                        new_state.change_flightboparameter = false;
                        new_state.delete_flightboparameter = false;
                        break;
                    case 'view_customaccommodation':
                        new_state.add_customaccommodation = false;
                        new_state.change_customaccommodation = false;
                        new_state.delete_customaccommodation = false;
                        break;
                    case 'view_customflight':
                        new_state.add_customflight = false;
                        new_state.change_customflight = false;
                        new_state.delete_customflight = false;
                        break;
                    case 'view_circuits':
                        new_state.add_circuits = false;
                        new_state.change_circuits = false;
                        new_state.delete_circuits = false;
                        break;
                    case 'view_packages':
                        new_state.add_packages = false;
                        new_state.change_packages = false;
                        new_state.delete_packages = false;
                        break;
                    case 'view_packagecategory':
                        new_state.add_packagecategory = false;
                        new_state.change_packagecategory = false;
                        new_state.delete_packagecategory = false;
                        break;
                    case 'view_circuitcancellationrule':
                        new_state.add_circuitcancellationrule = false;
                        new_state.change_circuitcancellationrule = false;
                        new_state.delete_circuitcancellationrule = false;
                        break;
                    case 'view_mapcustomprovider':
                        new_state.add_mapcustomprovider = false;
                        new_state.change_mapcustomprovider = false;
                        new_state.delete_mapcustomprovider = false;
                        break;
                    case 'view_roominglist':
                        new_state.add_roominglist = false;
                        new_state.change_roominglist = false;
                        new_state.delete_roominglist = false;
                        break;
                    case 'view_quotationtemplate':
                        new_state.add_quotationtemplate = false;
                        new_state.change_quotationtemplate = false;
                        new_state.delete_quotationtemplate = false;
                        break;
                    case 'view_quotationcategories':
                        new_state.add_quotationcategories = false;
                        new_state.change_quotationcategories = false;
                        new_state.delete_quotationcategories = false;
                        break;
                    case 'view_quotationrubrics':
                        new_state.add_quotationrubrics = false;
                        new_state.change_quotationrubrics = false;
                        new_state.delete_quotationrubrics = false;
                        break;
                    case 'view_eventsite':
                        new_state.add_eventsite = false;
                        new_state.change_eventsite = false;
                        new_state.delete_eventsite = false;
                        break;
                    case 'view_automaticproduct':
                        new_state.delete_automaticproduct = false;
                        new_state.change_automaticproduct = false;
                        new_state.add_automaticproduct = false;
                        break;
                    case 'view_customproductpricemodel':
                        new_state.delete_customproductpricemodel = false;
                        new_state.change_customproductpricemodel = false;
                        new_state.add_customproductpricemodel = false;
                        break;
                    case 'view_modelmail':
                        new_state.add_modelmail = false;
                        new_state.change_modelmail = false;
                        new_state.delete_modelmail = false;
                        break;
                    case 'view_translation':
                        new_state.add_translation = false;
                        new_state.change_translation = false;
                        new_state.delete_translation = false;
                        break;
                    case 'view_emailcontact':
                        new_state.add_emailcontact = false;
                        new_state.change_emailcontact = false;
                        new_state.delete_emailcontact = false;
                        break;
                    case 'view_roadbook':
                        new_state.add_roadbook = false;
                        new_state.change_roadbook = false;
                        new_state.delete_roadbook = false;
                        break;
                    case 'view_roadbookcategory':
                        new_state.add_roadbookcategory = false;
                        new_state.change_roadbookcategory = false;
                        new_state.delete_roadbookcategory = false;
                        break;
                    case 'view_roadbookrubric':
                        new_state.add_roadbookrubric = false;
                        new_state.change_roadbookrubric = false;
                        new_state.delete_roadbookrubric = false;
                        break;
                    case 'view_roadbookpicturetype':
                        new_state.add_roadbookpicturetype = false;
                        new_state.change_roadbookpicturetype = false;
                        new_state.delete_roadbookpicturetype = false;
                        break;
                    case 'view_roadbookconfiguration':
                        new_state.add_roadbookconfiguration = false;
                        new_state.change_roadbookconfiguration = false;
                        new_state.delete_roadbookconfiguration = false;
                        break;
                    case 'view_insurance':
                        new_state.add_insurance = false;
                        new_state.change_insurance = false;
                        new_state.delete_insurance = false;
                        break;
                    case 'view_insuranceproductfamily':
                        new_state.add_insuranceproductfamily = false;
                        new_state.change_insuranceproductfamily = false;
                        new_state.delete_insuranceproductfamily = false;
                        break;
                    case 'view_insurancedocument':
                        new_state.add_insurancedocument = false;
                        new_state.change_insurancedocument = false;
                        new_state.delete_insurancedocument = false;
                        break;
                    case 'view_insuranceminisitegeneration':
                        new_state.add_insuranceminisitegeneration = false;
                        new_state.change_insuranceminisitegeneration = false;
                        new_state.delete_insuranceminisitegeneration = false;
                        break;
                    case 'view_insurancescontract':
                        new_state.add_insurancescontract = false;
                        new_state.change_insurancescontract = false;
                        new_state.delete_insurancescontract = false;
                        break;
                    case 'view_insuranceproductdiscount':
                        new_state.add_insuranceproductdiscount = false;
                        new_state.change_insuranceproductdiscount = false;
                        new_state.delete_insuranceproductdiscount = false;
                        break;
                    case 'view_insuranceincentive':
                        new_state.add_insuranceincentive = false;
                        new_state.change_insuranceincentive = false;
                        new_state.delete_insuranceincentive = false;
                        break;
                    case 'view_warranty':
                        new_state.add_warranty = false;
                        new_state.change_warranty = false;
                        new_state.delete_warranty = false;
                        break;
                    case 'view_claimsmotif':
                        new_state.add_claimsmotif = false;
                        new_state.change_claimsmotif = false;
                        new_state.delete_claimsmotif = false;
                        break;
                    case 'view_network_director':
                        new_state.add_network_director = false;
                        new_state.change_network_director = false;
                        new_state.delete_network_director = false;
                        break;
                    case 'view_commercial':
                        new_state.add_commercial = false;
                        new_state.change_commercial = false;
                        new_state.delete_commercial = false;
                        break;
                    case 'view_commercialinformation':
                        new_state.add_commercialinformation = false;
                        new_state.change_commercialinformation = false;
                        new_state.delete_commercialinformation = false;
                        break;
                    case 'view_paymentcenter':
                        new_state.add_paymentcenter = false;
                        new_state.change_paymentcenter = false;
                        new_state.delete_paymentcenter = false;
                        break;
                    case 'view_purchases':
                        new_state.add_purchases = false;
                        new_state.change_purchases = false;
                        new_state.delete_purchases = false;
                    case 'view_accountingbook':
                        new_state.add_accountingbook = false;
                        new_state.change_accountingbook = false;
                        new_state.delete_accountingbook = false;
                        break;
                    case 'view_invoicehistory':
                        new_state.add_invoicehistory = false;
                        new_state.change_invoicehistory = false;
                        new_state.delete_invoicehistory = false;
                        break;
                    case 'view_invoicehistory':
                        new_state.add_accountsettings = false;
                        new_state.change_accountsettings = false;
                        new_state.delete_accountsettings = false;
                        break;
                    case 'view_invoicehistory':
                        new_state.add_exportsettings = false;
                        new_state.change_exportsettings = false;
                        new_state.delete_exportsettings = false;
                        break;
                    case 'view_settlement':
                        new_state.add_settlement = false;
                        new_state.change_settlement = false;
                        new_state.delete_settlement = false;
                        break;
                }
            }
            return { ...new_state };
        }
        default:
            return state;
    }
};